import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {
  FormGroupDirective,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { getServerErrorForField } from '@shared/helpers/form-helper';

import { required } from '../../decorators/required.decorator';
import { originalOrder } from '../../pipes/keyvalue-pipe-sort';

@Component({
  selector: 'app-subform-base',
  template: ``,
  styles: [],
})
export abstract class SubformBaseComponent implements OnInit {
  /**
   * the base path leading to this subform's localization, eg.:
   *    'PRODUCTS.ALCOHOLIC_DRINK_PROPERTIES.SPIRIT.RUM'
   * without a dot (.) in the end
   *
   * used by TITLE, PLACEHOLDER, HINT and TOOLTIP
   */
  abstract DICT_PATH: string;

  @Input() @required groupName!: string;

  group!: UntypedFormGroup;

  constructor(
    readonly parent: FormGroupDirective,
    readonly fb: UntypedFormBuilder,
    readonly changeDetector: ChangeDetectorRef,
    readonly translateService: TranslateService
  ) {}

  get TITLE(): string {
    return this.DICT_PATH + '.TITLE.';
  }
  get PLACEHOLDER(): string {
    return this.DICT_PATH + '.PLACEHOLDER.';
  }
  get HINT(): string {
    return this.DICT_PATH + '.HINT.';
  }
  get TOOLTIP(): string {
    return this.DICT_PATH + '.TOOLTIP.';
  }
  get REQUIRED(): string {
    return this.HINT + 'REQUIRED';
  }

  /**
   * prevents keyvalue pipe from sorting properties, maintaining the order of the original object / enum
   * usage:
   *   {{ someEnum | keyvalue:originalOrder }}
   */
  originalOrder = originalOrder;

  /** overriding method must call super.ngOnInit() first */
  ngOnInit(): void {
    this.group = this.parent.form.get(this.groupName) as UntypedFormGroup;
  }

  /** get a control by name form the subform */
  getCtrl(controlName: string): UntypedFormControl | undefined {
    return this.group.get(controlName) as UntypedFormControl | undefined;
  }

  /** get a control by name form the root form */
  getRootCtrl(controlName: string): UntypedFormControl | undefined {
    return this.group.root.get(controlName) as UntypedFormControl | undefined;
  }

  /** remove a control from the subform */
  rmCtrl(controlName: string) {
    return this.group.removeControl(controlName);
  }

  getServerError(fieldName: string): any {
    return getServerErrorForField(this.parent.form, fieldName);
  }
}
